import { FileBase } from './base';

export class ServiceOrderFile extends FileBase {}
